<mat-expansion-panel class="mat-elevation-z" [expanded]="true">
  <mat-expansion-panel-header expandedHeight="54px" collapsedHeight="54px" fxLayout="row">
    <mat-panel-title fxLayout="column" fxFlex="100">
      <div fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="start center">
        <h3 class="font-weight-semibold">{{ coloredYarnSetWithStartDent.coloredYarnSet.name }}</h3>
        <app-color-list-preview
          [colorList]="coloredYarnSetWithStartDent.coloredYarnSet.overviewListColorSet"
          [maximumCreelPositionsToShow]="10"
          [creelMapping]="activeColoredYarnSetCreelMap ?? null"
          (click)="$event.stopPropagation()"
        >
        </app-color-list-preview>
      </div>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <div fxLayout="row">
    <div fxLayout="column" fxLayoutGap="16px" fxFlex>
      <div fxLayout="row">
        <h3 class="font-weight-semibold" fxLayout="column">
          {{ 'MACHINE.DETAILS.CREEL_MAPPING.TITLE' | bmsTranslate }}
        </h3>
        <div fxLayout="column" fxLayoutAlign="start end" fxFlex>
          <div fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="start center">
            <mat-label class="b1">{{ 'TEXTILE_DATA.COLOR.COLOR' | bmsTranslate: {count: 2} }}</mat-label>
            <mat-slide-toggle (change)="onPreviewTypeChange($event)"></mat-slide-toggle>
            <mat-label class="b1">{{ 'TEXTILE_DATA.YARN_TYPE.YARN_TYPE' | bmsTranslate: {count: 2} }}</mat-label>
          </div>
        </div>
      </div>
      <div fxLayout="row">
        <app-creel-mapping-table
          [coloredYarnSetWithStartDent]="coloredYarnSetWithStartDent"
          [previewType]="previewType"
          [activeColoredYarnSetCreelMap]="activeColoredYarnSetCreelMap"
          (creelMapUpdate)="updateCreelMap($event)"
        ></app-creel-mapping-table>
      </div>
    </div>
  </div>
</mat-expansion-panel>
